import login from './login';
import account from './account';
import authorization from './authorization';
import unauthorized from './unauthorized';
import sellerReference from './sellerReference';

export default {
  login,
  account,
  authorization,
  unauthorized,
  sellerReference,
  shared: {
    phoneNumber: 'Telefon Numarası',
    email: 'E-Posta',
    required: 'Zorunlu bir alandır.',
  },
  reset: {
    createPassword: 'Şifrenizi Oluşturun',
    newPassword: 'Yeni Şifreniz',
    newPasswordAgain: 'Yeni Şifrenizi Doğrulayınız',
    placeholder: {
      newPassword: 'Yeni şifrenizi giriniz...',
    },
    validationRules: {
      min: 'Şifreniz en az 8 karakterden oluşmalıdır.',
      noNumber: 'Şifreniz en az bir rakam içermelidir.',
      noUpperAndLowerCase: 'Şifreniz en az bir büyük ve bir küçük harf içermelidir.',
      noSpecialCharacter: 'Şifreniz en az bir özel karakter (~`!@#$%^&*()_-+={[}]|\\:;\\"\'<\\,>\\.?/) içermelidir.',
    },
    genericValidationError: 'Şifreniz belirtilen kriterlere uygun değildir.',
    notMatchPasswords: 'Girilen şifreler uyuşmuyor',
    validationRulesTitle: 'Şifreniz Aşağıda Belirtilen Kriterlere Uymalıdır:',
    changeAndLoginBtn: 'Şifreyi Oluştur ve Giriş Yap',
  },
  forgot: {
    sentAgainLink: 'Bağlantıyı Tekrar Gönder',
    sentAgainCode: 'Kodu Tekrar Gönder',
    verifyCode: 'Kodu Doğrula',
    renewPassword: 'Şifrenizi Yenileyin',
    info: 'Şifrenizi yenilemeniz için, <b>Trendyol Satıcı Paneli’ne kayıtlı</b> telefon numaranıza veya e-posta adresinize ihtiyacımız var.',
    buttons: {
      phone: 'Kodu Gönder',
      email: 'Bağlantıyı Gönder',
    },
    links: {
      returnLoginPage: 'Giriş Sayfasına Geri Dön',
      beSellerInTrendyol: 'Şimdi Trendyol’da Satıcı Olun',
    },
    isNotSeller: 'Satıcı Değil Misiniz?',
    placeholders: {
      email: 'E-posta adresinizi giriniz...',
      phone: '0 (5__) ___ __ __',
    },
    flows: {
      otp: {
        sentRenewPasswordToEmail: '<b>{phoneNumber}</b> numaranız trendyol sisteminde satıcı olarak kayıtlı ise şifre yenileme kodunuz gönderilmiştir.',
        subTitle: 'Şifre yenileme kodu elinize ulaşmadıysa:',
        list: {
          one: 'Girdiğiniz telefon numarasını kontrol ediniz.',
          two: 'Eğer hala mesaj elinize ulaşmadıysa tekrar deneyiniz.',
        },
      },
      email: {
        sentRenewPasswordToEmail: '<b>{email}</b> email adresiniz trendyol sisteminde satıcı olarak kayıtlı ise mail gönderilmiştir.',
        subTitle: 'Şifre yenileme e-postası elinize ulaşmadıysa:',
        list: {
          one: 'Spam klasörünü kontrol ediniz.',
          two: 'Girdiğiniz e-posta adresini kontrol ediniz.',
          three: 'Eğer hala e-posta elinize ulaşmadıysa tekrar deneyiniz.',
        },
      },
    },
  },
};
